<template>
  <ContenedorCampos :titulo="titulo" :isObligatorio="Obligatorio" :error="error">
    <v-col cols="12" lg="6">

      <v-text-field
        v-model="hora"
        label="Seleccione una Hora"
        hint="HH:MM (ej: 14:30)"
        persistent-hint
        prepend-icon="mdi-clock-outline"
        readonly
        @click="dialogHora = true"
      />

      <HoraGeneral
        v-model="hora"
        :dialog.sync="dialogHora"
      />

    </v-col>
  </ContenedorCampos>
</template>

<script>
import ContenedorCampos from '@/components/dinamicos/ContenedorCampos.vue'
import DinamicosMixin from '@/mixins/dinamicosMixin.js'
import HoraGeneral from '@/components/dinamicos/compAuxiliares/HoraGeneral.vue';

export default {
  name: 'Hora',
  mixins: [ DinamicosMixin ],
  components: {
    ContenedorCampos,
    HoraGeneral,
  },
  data () {
    return {
      showPicker: false,
      hora: null,
      dialogHora: false
    }
  },
  watch: {
    hora (newHora) {
      this.selectValue = newHora
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
